import { render, staticRenderFns } from "./OpeningDoor.vue?vue&type=template&id=09b36534&scoped=true&"
import script from "./OpeningDoor.vue?vue&type=script&lang=js&"
export * from "./OpeningDoor.vue?vue&type=script&lang=js&"
import style0 from "./OpeningDoor.vue?vue&type=style&index=0&id=09b36534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b36534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
